export function objectsEqual<T>(o1: T, o2: T): boolean {
    if (!o1 || !o2) return false;
    return typeof o1 === 'object' && Object.keys(o1).length > 0
        ? Object.keys(o1).length === Object.keys(o2).length &&
              Object.keys(o1).every((p) => objectsEqual(o1[p as keyof T], o2[p as keyof T]))
        : o1 === o2;
}

export default <TArray = unknown, T = unknown>(a: TArray, b: TArray, sort?: (a: T, b: T) => number) => {
    if (a === b) return true;
    if (a == null || b == null) return false;
    if (!Array.isArray(a) || !Array.isArray(b)) return false;
    if (a.length !== b.length) return false;

    const doObjectCheck = a.some((x) => typeof x === 'object') || b.some((x) => typeof x === 'object');

    const tempA = a.sort(sort);
    const tempB = b.sort(sort);

    if (doObjectCheck) {
        return tempA.every((o, i) => objectsEqual(o, tempB[i]));
    }
    for (let i = 0; i < tempA.length; i += 1) {
        if (tempA[i] !== tempB[i]) return false;
    }
    return true;
};
